import { auth } from 'firebase/app';
import { DreamWebDAO } from '@/web/dao';
import store from '@/store';

export class WebAuth {
  private static instance: WebAuth;

  public constructor() {
    return;
  }

  public static getInstance() {
    if (!WebAuth.instance) {
      WebAuth.instance = new WebAuth();
    }
    return this.instance;
  }

  public logout(): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        DreamWebDAO.getInstance().unsubscribeToMyDreamsListChanges();
        store.dispatch('logout');
        auth().signOut();
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }
}
